import StatutoryComponents from "../Statutary/StatutoryComponents";

export default function PfSettings() {
  return <StatutoryComponents forcedTab="epf" />;
}
